import { type FC } from 'react';
import {
  CaretLeft
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCaretLeftProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCaretLeft: FC<UiIconCaretLeftProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CaretLeft}
      {...props}
    />
  );
};
